<template>
  
  <v-footer height="auto" app inset>
    <v-card flat tile class="white text-xs-center elevation-0" width="100%">
      <mobile-menu v-if="isMobileApp" />
      <powered-by v-else />
    </v-card>
  </v-footer>

</template>

<script>

  import PoweredBy from './PoweredBy'
  import MobileMenu from './MobileMenu'

  export default {
    name: 'Footer',
    data () {
      return {
      }
    },
    components: {
      'powered-by': PoweredBy,
      'mobile-menu': MobileMenu,
    }
  }

</script>

<style scoped>
  
  .mobile-app .v-card {
    padding: 3px 0;
  }

</style>
